import React, { useMemo } from "react";
import bannerPurpleMetrics from "assets/images/banner-purple-metrics.png";

import {
  ContentBannerPurpleMetrics,
  ImageBannerPurpleMetrics,
  LinkPurpleMetrics,
} from "./styles";

const BannerFraude: React.FC = () => {
  const urlDashBoard = useMemo(() => {
    if (
      process.env.REACT_APP_ENV === "build-prod" ||
      process.env.REACT_APP_ENV === "prod"
    ) {
      return "https://dashboard.purplemetrics.com.br/widget/survey/index.html?company=634118e1-c91a-46f0-a3b7-f78d874aaead&segment=402";
    }
    return "https://dashboard.purplemetrics.com.br/widget/survey/index.html?company=634118e1-c91a-46f0-a3b7-f78d874aaead&segment=402&isDebug=true";
  }, []);

  return (
    <ContentBannerPurpleMetrics>
      <LinkPurpleMetrics href={urlDashBoard} rel="noreferrer" target="_blank">
        <ImageBannerPurpleMetrics src={bannerPurpleMetrics} />
      </LinkPurpleMetrics>
    </ContentBannerPurpleMetrics>
  );
};

export default BannerFraude;
